import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import get from 'lodash.get';

import NotificationsSpinner from './NotificationsSpinner';
import NotificationCard from './NotificationCard';
import InfiniteScroll from './InfiniteScroll';
import EmailIcon from 'dibs-vg/dist/react/email';
import NotificationsPromoCode from './NotificationsPromoCode';

import styles from './Notifications-style.scss';

const getConversationsURL = conversationID => `/my/conversations/${conversationID}`;

const NotificationsList = ({ conversationEdges, loadMore, hasMore, isPromoCodeEligible }) => {
    const notificationNodes = conversationEdges.map(({ node }) => {
        const dealerName = get(node, 'otherMember.seller.sellerProfile.company') ||
                <FormattedMessage
                    id='dbl.Header.Notifications.dealer_name'
                    defaultMessage='1stdibs Seller'
                />;
        return (
            <NotificationCard
                key={node.serviceId}
                thumbnail={node.inboxImage}
                thumbnailAlt={get(node, 'item.title')}
                subject={`${dealerName}`}
                actionTitle={node.latestMessage}
                date={node.latestMessageReceivedAt}
                onClick={() => {window.location.href = getConversationsURL(node.serviceId);}}
                rightSecondary={<div className={styles.emailIcon}><EmailIcon /></div>}
            />
        );
    });

    return (
        <InfiniteScroll
            loadMore={loadMore}
            hasMore={hasMore}
            loader={<NotificationsSpinner key="notificationsLoading" size="small" hideOverlay />}
        >
            {notificationNodes}
            {isPromoCodeEligible && <NotificationsPromoCode />}
        </InfiniteScroll>
    );
};

NotificationsList.propTypes = {
    conversationEdges: PropTypes.array,
    loadMore: PropTypes.func.isRequired,
    hasMore: PropTypes.bool,
    isPromoCodeEligible: PropTypes.bool
};

NotificationsList.defaultProps = {
    isPromoCodeEligible: false
};

export default NotificationsList;



// WEBPACK FOOTER //
// ./src/components/Notifications/NotificationsList.jsx